import cn from 'clsx'
import { FC, useState } from 'react'
import CartItem from '../CartItem'
import { useUI } from '@components/ui/context'
import { Bag, Cross, Check } from '@components/icons'
import useCart from '@framework/cart/use-cart'
import CartRecommendedProducts from '../CartRecommendedProducts'
import CartSidebarLayout from '../CartSidebarLayout'

const ns = `cart-sidebar-view`

interface Props {
  customersAlsoBoughtData: any
  cartPromo: string
}

const CartSidebarView: FC<Props> = ({ customersAlsoBoughtData, cartPromo }) => {
  const { closeSidebar } = useUI()
  const { data, isLoading, isEmpty } = useCart()

  const handleClose = () => {
    closeSidebar()
    handleSidebarClose()
  }

  const [filteredProducts, setFilteredProducts] = useState(Array<any>)

  const handleSidebarClose = () => {
    const element = document.getElementById('launcher')
    if (element) {
      element.style.opacity = '1'
      element.style.pointerEvents = 'auto'
    }
  }

  const error = null
  const success = null

  const rootClassnames = cn({
    [`${ns}`]: true,
    [`${ns}--no-carousel`]: filteredProducts?.length === 0,
  })

  return (
    <CartSidebarLayout
      className={rootClassnames}
      handleClose={handleClose}
      data={data}
      cartPromo={cartPromo}
    >
      {isLoading || isEmpty ? (
        <>
          <div className={`${ns}__container`}>
            <h4 className={`${ns}__empty-heading`}>
              You have no items in your Cart.
            </h4>
          </div>
        </>
      ) : error ? (
        <div className={`${ns}__container`}>
          <span className={`${ns}__icon`}>
            <Cross width={24} height={24} />
          </span>
          <h4 className={`${ns}__heading`}>
            We couldn’t process the purchase. Please check your card information
            and try again.
          </h4>
        </div>
      ) : success ? (
        <div className={`${ns}__container`}>
          <span className={`${ns}__icon`}>
            <Check />
          </span>
          <h4 className={`${ns}__heading`}>Thank you for your order.</h4>
        </div>
      ) : (
        <div className={`${ns}__content`}>
          <ul className={`${ns}__line-items-list`}>
            {data?.lineItems.map((item: any) => (
              <CartItem
                key={item.id}
                item={item}
                currencyCode={data?.currency.code}
              />
            ))}
          </ul>
        </div>
      )}

      {customersAlsoBoughtData?.length && (
        <CartRecommendedProducts
          title={`Customers Also Bought`}
          data={data}
          products={customersAlsoBoughtData}
          filteredProducts={filteredProducts}
          setFilteredProducts={setFilteredProducts}
        />
      )}
    </CartSidebarLayout>
  )
}

export default CartSidebarView
